import { useCallback } from 'react';

import { useTripsBulkUnassignCreateMutation } from 'src/common/external/bambi-api/bambiApi';
import { formatServerError } from 'src/common/util/serverErrorFormatter';

import { useBulkUnMultiLoadOnBulkUnassign } from './useBulkUnMultiLoadOnBulkUnassign';

export function useBulkUnassignTrips() {
  const [unassignBulk] = useTripsBulkUnassignCreateMutation();
  const removeMultiLoadsForTripsToUnassign = useBulkUnMultiLoadOnBulkUnassign();

  const handleBulkUnassignTrips = useCallback(
    async (assignmentIds: string[]) => {
      if (assignmentIds.length === 0) {
        throw new Error('No assignment IDs provided');
      }

      let failedCount = 0;
      const errors: Record<string, string> = {};
      for (const assignmentId of assignmentIds) {
        try {
          await unassignBulk({
            bulkTripUnassign: { assignment_id: assignmentId },
          });

          await removeMultiLoadsForTripsToUnassign(assignmentId);
        } catch (error) {
          failedCount++;
          errors[assignmentId] = formatServerError(error);
        }
      }

      return {
        failedCount,
        successCount: assignmentIds.length - failedCount,
        errors,
      };
    },
    [unassignBulk, removeMultiLoadsForTripsToUnassign]
  );

  return { handleBulkUnassignTrips };
}
